

export const currentUrlFilterByName = (filterName) => {
  // On suppose qu'il n'y a qu'une seule occurence du filtre recherché
  return currentUrlQuery().filter(
    obj => obj.name === filterName
  )[0];
}

export const currentUrlQuery = () => {
  return window.location.search
    .replace("?", "")
    .split("&")
    .filter(v => v)
    .map(s => {
        s = s.replace("+", "%20");
        s = s.split("=").map(s => decodeURIComponent(s));
        return {
            name: s[0],
            value: s[1]
        };
    });
}
/**
 * Add/update/remove one or more parameters to the querystring and push the new url
 * to the history/ Args must be an arry of object
 * [{'label': 'paramlabel', 'value': 'paramvalue}]
 * Use null value to remove the parameter
 * @param {*} args
 */
export const setUrlQuery = (args) => {

  let url = '';
  const currentQuery = currentUrlQuery();
  let newQuery = [];

  // Put new args in the result query
  args.forEach( arg => {
    newQuery.push({name: arg.label, value: arg.value});
  });

  // Get current filters that are not in new args
  currentQuery.forEach(e => {
    if (!newQuery.find(o => o.name == e.name)){
      newQuery.push({name: e.name, value: e.value});
    }

  })
  // Build URL
  newQuery.forEach(e => {
    if (e.value){
      url += '&' + e.name + '=' + e.value;
    }
  });
  url = window.location.pathname + '?' + url.substring(1);

  // Push it into the history
  history.pushState(null, null, url);

}
